import { AutodeskDmFolder } from "../AutodeskDmFolder";
export class FrontendAutodeskDmFolder extends AutodeskDmFolder {}
